import React from 'react'
import ClientSuspense from '@components/ClientSuspense'
import Card from '@components/V3/Card'
import dynamic from 'next/dynamic'

import Confirm from './Confirm'
import PaymentMethod from './PaymentMethod'
import PaymentSkeleton from './Skeleton'
import Summary from './Summary'
import Tip from './Tip'

const ReducedDemand = dynamic(() => import('./ReducedDemand'))
const SpecialRequirements = dynamic(() => import('../../sections/SpecialRequirements'))
const Billing = dynamic(() => import('../../sections/Billing')) // No Skeleton since most countries won't show it

function Payment() {
  return (
    <>
      <Card transparentOnDesktop>
        <Tip />
        <Summary />
      </Card>
      <Card transparentOnDesktop>
        <Billing />
        <PaymentMethod />
        <SpecialRequirements />
        <Confirm />
        <ReducedDemand />
      </Card>
    </>
  )
}

export default function PaymentWrapper() {
  return (
    <ClientSuspense fallback={<PaymentSkeleton />}>
      <Payment />
    </ClientSuspense>
  )
}
